import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { Truck } from 'src/tmc-yard/widgets/control/truck-overview/truck.model';


@Component({
  selector: 'app-truck-gc-case-dialog',
  templateUrl: './truck-gc-case-dialog.component.html',
  styleUrls: ['./truck-gc-case-dialog.component.scss']
})
export class TruckGcCaseDialogComponent {

  truck: Truck;

  constructor(
    public dialogRef: MatDialogRef<TruckGcCaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translationService: TranslationService
  ) {
    this.truck = data.truck;
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
